angular.module('bmsApp.settings')
	.controller('LeavingPromptQuestionCtrl', LeavingPromptQuestionCtrl);

LeavingPromptQuestionCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'notify',
	'$ngBootbox',
	'LicenseOptionsSvc',
	'LeavingPromptQuestionSvc',
];

function LeavingPromptQuestionCtrl(
	$scope,
	$state,
	$q,
	notify,
	$ngBootbox,
	LicenseOptionsSvc,
	LeavingPromptQuestionSvc,
) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: true,
		handlers: handlers,
		options: {},
		processing: false,
	});

	this.$onInit = () => {
		self.loading = true;
		var promises = {
			licenses: LicenseOptionsSvc.license(),
		};

		$q.all(promises).then(function (responses) {
			self.options.licenses = responses.licenses.data.options;
			self.loading = false;
		});
	};

	function loadQuestions(){
		self.loading = true;
		var params = {
			filter:{
				license: self.license.id
			}
		};

		LeavingPromptQuestionSvc.index(params).then((response) => {
			self.questions = response.data.leaving_prompt_question_collection;
			self.loading = false;
		});
	}
	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.licenseChanged = () => {
		loadQuestions();
	};

	handlers.showModalForm = (question) => {
		self.processing = true;
		LeavingPromptQuestionSvc.showSaveModal(self.license, question).then((response) => {
			loadQuestions();
			self.processing = false;
		});
	};

	handlers.delete = (question, index) => {
		$ngBootbox.confirm('Are you sure you want to do this?')
			.then(function () {
				question.deleting = true;
				LeavingPromptQuestionSvc.remove(question.id).then((response) => {
					self.questions.splice(index,1);
				});
			});
	};

}
